import React, { useEffect } from 'react';
import gql from 'graphql-tag';
import styles from '../../src/admin/modules/layoutBuilder/components/Layout.scss';
import Component from '../components/RobotsSettings';
import useQuery from '../../modules/react/hooks/useQuery';
import useMutation from '../../modules/react/hooks/useMutation';

const GET_ROBOTS_DATA = gql`
  query GetCurrentSiteRobotsData {
    currentSite {
      id
      robots {
        ...RobotsSettingsRobots
      }
      ...RobotsSettingsSite
    }
  }

  ${Component.fragments.robots}
  ${Component.fragments.site}
`;

const UPDATE_ROBOTS_DATA = gql`
  mutation RobotsContentUpdate($content: String!) {
    robotsContentUpdate(content: $content) {
      robots {
        ...RobotsSettingsRobots
      }
      userErrors {
        code
        message
      }
    }
  }

  ${Component.fragments.robots}
`;

const RobotsSettings = () => {
  const { data: queryData, refetch } = useQuery(GET_ROBOTS_DATA, { fetchPolicy: 'network-only' });
  const [updateRobotsContent, { data, error, loading }] = useMutation(UPDATE_ROBOTS_DATA);

  useEffect(() => {
    if (data && !error && !loading) {
      refetch();
    }
  }, [data, error, loading]);

  let submitErrors = [];
  let submitted = false;
  if (data) {
    submitted = true;

    const { userErrors } = data.robotsContentUpdate;
    if (userErrors && userErrors.length > 0) {
      submitErrors = userErrors;
    }
  }

  if (error) {
    submitErrors = [...submitErrors, error];
  }

  if (!queryData) {
    return null;
  }

  const onSubmit = content => updateRobotsContent({ variables: { content } });

  return (
    <div className={styles.layout}>
      <Component
        onSubmit={onSubmit}
        site={queryData.currentSite}
        submitErrors={submitErrors}
        submitted={submitted}
        submitting={loading}
      />
    </div>
  );
};

export default RobotsSettings;
